import React, { createContext } from 'react';
import { TutorProfileService } from '../services/interfaces';

interface TutorProfileProviderProps {
  children: React.ReactNode;
  tutorProfileService: TutorProfileService;
}

interface TutorProfileContextProps {
  tutorProfileService: TutorProfileService;
  onEdit: () => void;
}
const TutorProfileContext = createContext<TutorProfileContextProps | undefined>(undefined);

export function DataStoreProvider({ children, tutorProfileService }: TutorProfileProviderProps): JSX.Element {

  const onEdit = () => { }
  const value = {
    tutorProfileService,
    onEdit
  }
  return (
    <TutorProfileContext.Provider value={value}>
      {children}
    </TutorProfileContext.Provider>
  );
}

export function useDataStoreService(): TutorProfileContextProps {
  const context = React.useContext(TutorProfileContext);
  if (context === undefined) {
    throw new Error('useDataStoreService must be used within a DataStoreProvider');
  }
  return context;
}
